import { render, staticRenderFns } from "./MarketplaceInvoices.vue?vue&type=template&id=02d83d78&scoped=true&"
import script from "./MarketplaceInvoices.vue?vue&type=script&lang=js&"
export * from "./MarketplaceInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d83d78",
  null
  
)

export default component.exports